import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuthHandling } from '../useAuthhandling';
import Config from '../Config';
import Cookies from 'js-cookie';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import moment from 'moment';
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

function Enquiryview() {
    const { isAuthorized, handleUnauthorized } = useAuthHandling();

    let navigate = useNavigate();
    const toggleRef = useRef(null);
  
    const tokens = Cookies.get("a_token");
    if (!tokens) {
      navigate("/");
    }
    const [location, setLocation] = useState({
      name: "",
      lat:"",
      long: "",
    });
  
    const [checke, setChecked] = useState("");
    const [addressstring, setaddressstring] = useState([]
    );
    const [enquiry, setEnquiry] = useState([]);
    const [testal, setTestval] = useState("");
    const [toggle, setToggle] = useState(false);

  
    const [levelName,setLevelName]=useState("");
    const [level1Name,setLevel1Name]=useState("");
    const [level1Id,setLevel1Id]=useState("");
    let { id } = useParams();
    const [catid,setCatid]=useState("");
    const [sdate, setSdate] = useState("");
  const [edate, setEdate] = useState("");
  const [cust, setCust] = useState([]);
  const [prof, setProf] = useState([]);


    const getinfo = async (e) => {
        const res = await fetch(
          `${Config.apiurl}/api/v1/crm/enquiry/get-enquiry/${id}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${Cookies.get("a_token")}`,
            },
          }
        );
        if (res.status === 200) {
          const data = await res.json();
    
          setEnquiry(data.data);
        
          setLevel1Id(data.data.enquiryParentCategoryId);
          setLevel1Name(data.data.enquiryParentCategoryName);
          setSdate(moment(data.data.enquiryDate).utc().format("YYYY-MM-DD"));
          setEdate(moment(data.data.enquiryExpiry).utc().format("YYYY-MM-DD"));

        } 
        else if(res.status === 401){
          handleUnauthorized();
          getinfo();
        }
        else {
          alert("error");
        }
      };

      const getprof = async (e) => {
        const res = await fetch(
          `${Config.apiurl}/api/v1/data/professionals-dropdown`,
          {
            method: "GET",
          }
        );
    
        const data1 = await res.json();
        const data = data1.data;
        if (res.status === 404 || !data) {
          console.log("error");
        } else {
          setProf(data);
        }
      };
    
      const getcust = async (e) => {
        const res = await fetch(
          `${Config.apiurl}/api/v1/crm/customer/get-customers-dropdown`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${Cookies.get("a_token")}`,
            },
          }
        );
    
        if (res.status === 200) {
          const data1 = await res.json();
          const data = data1.data;
          setCust(data);
        } 
        else if(res.status === 401){
          handleUnauthorized();
          getcust();
        }
        
      };
    
      useEffect(() => {
        getinfo();
        getprof();
        getcust();
      }, []);
  return (
    <div className="container-scroller">
    <Navbar />

    <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
            <div className="content-wrapper">
                <div className='view_page_top'>
                    <Link to="/enquiry">Enquiry list</Link>
                    <Link to={"/editenquiry/" + id}>Edit</Link>
                </div>
                <div className="row">
                    <div className="col-md-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title">Enquiry View page</h4>

                                <div className='row view_div_row'>
                                <div className='col-6 '>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6>Enquiry ID </h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                <p> {enquiry.enquiryId}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-6 '>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6>Enquiry Category Name </h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                <p> {enquiry.enquiryCategoryName}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-6 '>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6>Enquiry Type </h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                <p> {enquiry.enquiryType}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-6 '>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6> Location </h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                <p>  {enquiry.location}</p>
                                            </div>

                                        </div>
                                    </div>
                                    <div className='col-6'>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6> Enquiry Date </h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                <p>  {sdate}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-6 '>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6> Enquiry Expiry Date </h6>
                                            </div>

                                            <div className='view_portion_p'>
                                                <p>  {edate}</p>
                                            </div>

                                        </div>
                                    </div>
                                   
                                    <div className='col-6 '>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6> Status</h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                <p>  {enquiry.status}</p>
                                            </div>

                                        </div>
                                    </div>
                                    <div className='col-6 '>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6> Agreed Terms </h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                <p>  {enquiry.agreedTerms===true?"Yes":"No"}</p>
                                            </div>

                                        </div>
                                    </div>
                                    <div className='col-6 '>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6> Customer </h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                {cust.map((cust,i)=>{
                                                    return(
                                                        <>
                                                        {cust._id===enquiry.enquiryUser?
                                                        <p> {cust.name}</p>
                                                        :""
                                                        }
                                                        </>
                                                    )
                                                })}
                                            </div>

                                        </div>
                                    </div>
                                    {enquiry.professional?
                                    <div className='col-6 '>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6> Professional </h6>
                                            </div>
                                            <div className='view_portion_p'>
                                            {prof.map((prof,i)=>{
                                                    return(
                                                        <>
                                                        {prof._id===enquiry.professional?
                                                        <p> {prof.name}</p>
                                                        :""
                                                        }
                                                        </>
                                                    )
                                                })}
                                            </div>

                                        </div>
                                    </div>
                                    :""}

{enquiry.enquiryParentCategoryName?
                                    <div className='col-6 '>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6> Parent Category </h6>
                                            </div>
                                            <div className='view_portion_p'>
                                           <p>{enquiry.enquiryParentCategoryName}</p>
                                            </div>

                                        </div>
                                    </div>
                                    :""}
                                    <div className='col-12 '>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6> Requirement </h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                <p>{enquiry.requirement}</p>
                                            </div>

                                        </div>
                                    </div>
                                    <div className='col-12 '>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6 view_portion_h6_togg' onClick={(e)=>setToggle(!toggle)}>
                                                <h6> Professional Responses </h6>
                                                {toggle?
                                                <span><IoIosArrowUp /></span>
                                                :
                                                <span><IoIosArrowDown /></span>
                                                }
                                            </div>
                                            {toggle?
                                             enquiry.professionalResponse.length>0?
                                            enquiry.professionalResponse.map((response,i)=>{
                                                return(
                                                    <div className='view_portion_p view_response_enq'>
                                                        <div className='row'>

                                                            <div className='col-6 col-md-3'>
                                                                Professional
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                {prof.map((prof,i)=>{
                                                    return(
                                                        <>
                                                        {prof._id===response.professional?
                                                        <p> {prof.name}</p>
                                                        :""
                                                        }
                                                        </>
                                                    )
                                                })}
                                                                 
                                                                </div>    
                                                                {enquiry.enquiryType==='Direct-enquiry' && enquiry.professionalResponse?.length > 0 && enquiry?.professionalResponse[0]?.response === false?
                                                                <>
                                                                <div className='col-6 col-md-3'>
                                                                 Professional Reject
                                                                 </div>
                                                                 <div className='col-6 col-md-9'>
                                                                 <p>Yes</p>
                                                                  
                                                                 </div>
                                                                 <div className='col-6 col-md-3'>
                                                                 Rejected Reason
                                                                 </div>
                                                                 <div className='col-6 col-md-9'>
                                                                 <p>{response.responseText}</p>
                                                                  
                                                                 </div>
                                                                 </>
                                                                 :""}
                                                                {response.response===true?
                                                                <>
                                                               
                                                                 <div className='col-6 col-md-3'>
                                                                 Response
                                                                 </div>
                                                                 <div className='col-6 col-md-9'>
                                                                 <p>{response.responseText}</p>
                                                                  
                                                                 </div>
                                                                 </>
                                                                 :""}

                                                                
                                                               
                                                                 <div className='col-6 col-md-3'>
                                                                 User Accepted
                                                                 </div>
                                                                 <div className='col-6 col-md-9'>
                                                                 {response.userAccepted===true?
                                                                 <p>Yes</p>
                                                                 :<p>No</p>
                                            }
                                                                  
                                                                 </div>
                                                                 <div className='col-6 col-md-3'>
                                                                 User Rejected
                                                                 </div>
                                                                 <div className='col-6 col-md-9'>
                                                                 {response.userReject===true?
                                                                 <p>Yes</p>
                                                                 :<p>No</p>
                                                                 }
                                                                 </div>
                                                                
                                                               
                                                              
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            : 
                                            <div className='view_portion_p'>
                                                professional response is pending...
                                                </div>
                                            :""}

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
  )
}

export default Enquiryview
